<div class="page-container">
  <app-configurable-grid
    headerTitle="Requirements"
    [config]="gridConfig">
  </app-configurable-grid>
</div>
